module.exports = __webpack_public_path__ + "img/green.88c04532.svg";